module.exports = __webpack_public_path__ + "img/about-bg.91046622.png";